import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import { config } from '@/config';

Vue.use(VueI18n);

const defaultLocale: string = config.i18n.defaultLocale;
const loadedLocales: string[] = [];

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: {
    [defaultLocale]: require(`./resource/i18n/${defaultLocale}.json`),
  },
});

const setLocale = (locale: string) => {
  i18n.locale = locale;
  axios.defaults.headers.common['Accept-Language'] = locale;
  document.querySelector('html')!.setAttribute('lang', locale);
  return locale;
};

export const loadLocaleAsync = (locale: string): Promise<any> => {
  if (i18n.locale !== locale) {
    if (!loadedLocales.includes(locale)) {
      return import(/* webpackChunkName: "lang-[request]" */ `./resource/i18n/${locale}.json`)
        .then((messages) => {
          i18n.setLocaleMessage(locale, messages.default);
          loadedLocales.push(locale);
          return setLocale(locale);
        })
        .catch((error) => {
          // tslint:disable-next-line:no-console
          console.debug(`Unable to load translation`);
        });
    }
    return Promise.resolve(setLocale(locale));
  }
  return Promise.resolve(locale);
};

export default i18n;
